import { r as e, t } from "../../chunks/index.es.wVhS2yfK.js";
import { Node as n, Transforms as r } from "slate";
// lib/List/lib/normalizeNode.tsx
var i = (i, a, o) => {
	let [, s] = a, c = Array.from(n.children(i, s)), l = 0;
	for (let [n, a] of c) {
		if (e.isBlock(n)) return r.unwrapNodes(i, {
			at: a,
			split: !0
		}), !0;
		if (l < c.length && e.isText(n) && !e.isOfType(n, `${o}/list-item`)) return r.setNodes(i, { type: `${o}/list-item` }, { at: a }), !0;
		if (l === c.length - 1 && c.length > 1 && e.isOfType(n, `${o}/list-item`) && !t.hasText([c[l - 1], c[l]])) {
			let e = [...s, l - 1], t = [...s, l];
			return r.setNodes(i, {
				type: "core/text",
				properties: {}
			}, { at: t }), r.liftNodes(i, { at: t }), r.removeNodes(i, { at: e }), !0;
		}
		l++;
	}
};
export { i as normalizeNode };
